<template>
  <div class="height">
      <div class="device-swipe">
          <van-swipe class="my-swipe" :key="swipeKey" :autoplay="code.images_video.swipe_interval*1000" indicator-color="white" v-if="code && code.images_video.swipe_type==1">
            <van-swipe-item v-for="(images,index) in code.images_video.images" v-bind:key="index">
              <img :src="images.url"/>
            </van-swipe-item>
          </van-swipe>
          <video class="dev-swipe" loop muted autoplay controls v-if="code && code.images_video.swipe_type==2">
            <source
              :src="code.images_video.video"
              type="video/mp4"
            />
          </video>
      </div>
      <div class="device-bottom" v-if="netSuccess">
        <div class="device-main" @click="useFun">开始使用</div>
        <div class="flex flex-x">
            <div class="flex">
                <div class="device-num" v-if="code">设备编号：<span>{{code.info.equipment_code}}</span></div>
                <div class="device-num device-history" v-if="code && code.info.testing_type!==4" @click="historyLoginFun">历史记录</div>
            </div>
        </div>
      </div>
      <div class="device-bottom " v-if="netError">
          <div class="device-net-msg">请检测您的网络连接</div>
          <div class="device-net-retry flex flex-x" @click="retryFun">
              <div class="device-agin">重新连接</div>
              <div class="device-icon">
                <van-icon name="replay"/>
              </div>
          </div>
      </div>
      
      <div v-if="show">
        <vue-popup url="confirmAssess" :showFun="showFun" audio="welcome" />
      </div>
      
      <div class="yt-jpg flex flex-y flex-x" v-if="show1">
          <div class="yt-ugk" v-if="insura_state==1">
              <div class="yt-box ">
                  <div class="yt-jb">
                      <div class="insura-title">请选择登录方式</div>
                      <div class="yt-cross" @click="cross">
                        <van-icon name="cross" />
                      </div>
                  </div>
                  <div class="yt-top-g">
                    <div v-if="swipe.indexOf('1')!==-1">
                        <div class="yt-top flex flex-y flex-x">
                          <div  class="yt-box-sao">
                              <div class="sao-jo" @click="idFun">
                                  <div class="sao-title-box">身份证登录</div>
                              </div>
                          </div>
                          <div  class="yt-box-sao" @click="writeFun">
                              <div class="sao-jo">
                                  <div class="sao-title-box">手动输入身份证</div>
                              </div>
                          </div>
                        </div>
                    </div>
                    
                    <div class="yt-top flex flex-y flex-x" v-if="swipe.indexOf('2')!==-1">
                      <div  class="yt-box-sao flex-1" @click="hospitalFun">
                          <div class="sao-jo">
                              <div class="sao-title-box">医保卡登录</div>
                          </div>
                      </div>
                    </div>
                    
                    <div class="yt-top flex flex-y flex-x" v-if="swipe.indexOf('3')!==-1">
                      <div  class="yt-box-sao flex-1" @click="codeFun">
                          <div class="sao-jo">
                              <div class="sao-title-box">扫码登录</div>
                          </div>
                      </div>
                    </div>
                  </div>
              </div>
          </div>
          <div v-if="insura_state==5" :class="`${write?'':'top-id'} insura-box-bc`">
              <div class="insura-title flex">
                  <div class="insura-write"></div>
                  <div class="flex-1">身份证登录</div>
                  <div class="insura-write" >
                    <van-icon name="cross" @click="exitFun"/>
                  </div>
              </div>
              <div v-if="!write">
                <div class="id-write flex">
                  <div class="flex-1">姓名：</div>
                  <vue-chinese placeholder="请输入您的姓名" :inputMot="chineseInput"/>
                </div>
                <div class="id-write flex">
                  <div class="flex-1">身份证号：</div>
                  <div class="write_id" @click="()=>this.show2=true">
                    <span v-if="write_id">{{write_id}}</span>
                    <span v-else class="placeholder">请输入您的身份证号</span>
                  </div>
                </div>
                <div class="exit" @click="sumberFun">提交</div>
                <div class="keyboard-cover" @click="()=>{this.show2=false}" v-if="show2"></div>
                <div class="ask-clavier">
                  <van-number-keyboard
                    :show="show2"
                    extra-key="X"
                    @input="onInput"
                    @delete="onDelete"
                  />
                </div>
              </div>
              <div v-else>
                <div class="insura-box flex flex-x">
                  <div class="insura-img insura-jom flex flex-x">
                      <img src="../../../images/sfz.png"/>
                  </div>
                </div>
                <div class="insura-na">请将您的身份证放置在读卡区</div>
                <div class="exit" @click="identityFun">开始读卡</div>
              </div>
          </div>
          <div v-if="insura_state==4" :class="`insura_show insura-box-bc`">
              <div class="insura-iox flex">
                <div class="flex-1"></div>
                <div class="insura-return" @click="exitFun">✕</div>
              </div>
              <div class="insura-box">
                <div class="insura-na flex">
                  <div>姓名：</div>
                  <div class="insura-right flex-1">
                      {{info?info.userName:''}}
                  </div>
                </div>
                <div class="insura-na flex">
                  <div>身份证号：</div>
                  <div class="insura-right flex-1">
                      {{info?hidenNum(info.idCode,3,4):''}}
                  </div>
                </div>
                <div class="insura-na flex">
                  <div>出生年月：</div>
                  <div class="insura-right flex-1">{{info?info.birthday:''}}</div>
                </div>
                <div class="insura-na flex">
                  <div>手机号：</div>
                  <div class="flex-1"></div>
                  <div class="insura-right">
                    <div class="insura-input" @click="()=>this.show3=true">{{write_iphone?write_iphone:'非必填'}}</div>
                  </div>
                </div>
                <div class="keyboard-cover" @click="()=>this.show3=false" v-if="show3"></div>
                <div class="ask-clavier">
                  <van-number-keyboard
                    :show="show3"
                    @input="iphoneInput"
                    @delete="iphoneDelete"
                  />
                </div>
              </div>
              <div class="que-d" @click="questionFun">确定</div>
          </div>
          <div v-if="insura_state==6" :class="`insura-box-bc`">
              <div class="insura-title flex">
                  <div class="insura-write"></div>
                  <div class="flex-1">扫码登录</div>
                  <div class="insura-write" >
                    <van-icon name="cross" @click="exitFun"/>
                  </div>
              </div>
              <div class="insura-box flex flex-x">
                <div class="insura-img insura-jom flex flex-x">
                    <img src="../../../images/sweep.png"/>
                </div>
              </div>
              <div class="insura-na">请将二维码放到扫码口</div>
              <div class="exit" @click="codeIfun">开始扫码</div>
          </div>
          <div v-if="insura_state==7" :class="`insura-box-bc`">
              <div class="insura-title flex">
                  <div class="insura-write"></div>
                  <div class="flex-1">医保卡登录</div>
                  <div class="insura-write" >
                    <van-icon name="cross" @click="exitFun"/>
                  </div>
              </div>
              <div class="insura-box flex flex-x">
                <div class="insura-img insura-jom flex flex-x">
                    <img src="../../../images/sbk.png"/>
                </div>
              </div>
              <div class="insura-na">请将医保卡插入读卡器中</div>
              <div class="exit" @click="swipefun">开始读卡</div>
          </div>
      </div>
      <div v-if="history">
          <vue-popup :showFun="noLoginFun" url="reportList" :query="{return:true}" :login="true" text="搜索报告" />
      </div>

  </div>
</template>

<script>
import { mapActions , mapState , mapMutations } from 'vuex';
import vuePopup from "@/components/popup";
import vueChinese from "@/components/chinese";
import cameraDetector from "@/components/camera/cameraDetector";
import { audioPaly , isValidIDCard , extractInfoFromIDCard , isValidPhoneNumber } from "@/utils";
import { welcome  } from "@/utils/audio";
import { Toast } from 'vant';

export default {
  name: 'device',
  mixins: [cameraDetector],
  data(){
    return{
      show: false,
      show1:false,
      show2:false,
      show3:false,
      swipeKey:0,
      insura_state:1,
      insura_card:1,
      write:true,
      write_name:'',
      write_id:'',
      write_iphone:'',
      textareaValue:'',
      swipe:[]
    }
  },
  components:{
    vuePopup,
    vueChinese
  },
  created:function(){
      this.deviceFun(this.axiosFun);
      sessionStorage.removeItem('token');
      sessionStorage.removeItem('info');
      if(sessionStorage.device=='android'){
          //安卓使用H5摄像头
          if(this.$route.query.edtion && this.$route.query.edtion<2){
              sessionStorage.setItem("camera", "true");
          }
      }
  },
  destroyed: function () {
      this.changeFun({
        key:'history',
        value:false
      })
  },
  computed:{
    textChange:{
        get() { 
          return this.textareaValue
        },
        set(val){
          this.textareaValue = val;
          console.log(val);
        }
    },
    ...mapState('device',['code','info','netError','netSuccess']),
    ...mapState ("report", ['history']),
  },        
  methods:{
      //获取数据
      axiosFun(mac){
        this.axiosData({
          data:{mac:mac},
          _this:this
        });
      },
      cross(){
        this.show1=false
      },
      onInput(value) {
        this.write_id = this.write_id+value;
      },
      chineseInput(value){
        this.write_name = value;
      },
      iphoneInput(value) {
        this.write_iphone = this.write_iphone+value;
      },
      iphoneDelete() {
        this.write_iphone =  this.write_iphone.slice(0, -1);
      },
      onDelete(){
        this.write_id = this.write_id.slice(0, -1);
      },
      wxFun(){
        this.insura_state=6;
        this.show1=false;
      },
      wxEditFun(){
        this.insura_state=1;
        this.show1=true;
      },
      codeFun(){
        this.insura_state=6;
      },
      codeIfun(){
        this.codeData({data:{},fun:(data)=>{
          if(this.insura_state==6){
            console.log(data);
            this.insura_state=4;
            this.write_id = data.idCode;
            this.write_name = data.userName;
          }
        }});
      },
      swipefun(){
        this.swipeData({
          data:{},
          fun:(data)=>{
            if(this.insura_state==7){
              this.insura_state=4;
              this.write_id = data.idCode;
              this.write_name = data.userName;
            }
          }
        })
      },    
      writeFun(){
        this.insura_state=5;
        this.insura_card=1;
        this.write = false;
        this.write_name = '';
        this.write_id = '';
      },
      hospitalFun(){
        this.insura_state=7;
        this.insura_card=1;
        this.write = false;
        this.write_name = '';
        this.write_id = '';
      },
      idFun(){
        this.insura_state=5;
        this.insura_card=1;
      },
      identityFun(){

        this.identityData({data:{},fun:(data)=>{
          if(this.insura_state==5){
            this.insura_state=4;
            this.write_id = data.idCode;
            this.write_name = data.userName;
          }
        }});
      },
      sumberFun(){
        let bool = true;
        
        if(!this.write_name){
            bool = false;
            Toast('姓名不能为空!');
        }

        if(bool && !isValidIDCard(this.write_id)){
            bool = false;
            Toast('身份证格式有误!');
        }
        
        if(bool){
          let info = {
            userName:this.write_name,
            gender:extractInfoFromIDCard(this.write_id).gender,
            birthday:extractInfoFromIDCard(this.write_id).birthday,
            idCode:this.write_id
          };
          sessionStorage.setItem("info",JSON.stringify(info));

          this.changeDFun({
              key:'info',
              value:info
          })

          this.insura_state=4;
        }
      },
      exitFun(){
        this.insura_state=1;
        this.write = true;
      },
      questionFun(){
        let _this = this;
        let equipment = JSON.parse(sessionStorage.getItem('equipment'));
        if(this.write_iphone && isValidPhoneNumber(this.write_iphone)){
            this.axiosTel({
              data:{
                  company_id:equipment?equipment.sys_company_id:'',
                  phone:this.write_iphone,
                  name:'',
                  birthday:''
              },
              func:()=>{
                //设置个人信息
                this.userReviseData({
                  data:{
                    name:this.write_name,
                    phone:this.write_iphone,
                    birthday:extractInfoFromIDCard(this.write_id).birthday,
                    sex:extractInfoFromIDCard(this.write_id).gender=='男'?'1':'2'
                  },
                  func:()=>{
                    //语音
                    audioPaly.play(welcome);
                    _this.$router.push({
                        name:'confirmAssess'
                    });
                  }
                })
              }
            })
        }else{
            this.axiosTel({
              data:{
                  company_id:equipment?equipment.sys_company_id:'',
                  phone:'',
                  name:this.write_name,
                  birthday:extractInfoFromIDCard(this.write_id).birthday
              },
              func:()=>{
                //语音
                audioPaly.play(welcome);
                _this.$router.push({
                    name:'confirmAssess'
                });
              }
            })
        }
      },
      //身份证脱敏
      hidenNum(str, frontLen, endLen){
        if(str && str.length > 10){
          var len = str.length - frontLen - endLen;
          var xing = '';
          for (var i=0; i<len; i++) {
            xing += '*';
          }
          return str.substring(0, frontLen) + xing + str.substring(str.length - endLen);
        }
        return str;
      },
      //判断设备环境
      deviceFun(axiosFun){
        let device = sessionStorage.getItem('device');
        if(device=='windows'){
          let mac = localStorage.mac;
          if(mac){
              axiosFun(mac);
          }else{
              window.ipcRenderer.send("getMacAddress");
              window.ipcRenderer.on("setMacAddress", (e, msg) => {
                axiosFun(msg);
                localStorage.setItem("mac",msg);
              });
          }
        }else if(device=='android'||this.$route.query.mac){
          axiosFun(this.$route.query.mac);
        }
      },
      useFun(){
        let device = this.$store.state.device;
        let _this = this;
        if(device.code){
          if(device.code.info.testing_type==2){ //扫码
            this.show = true;
          }else if(device.code.info.testing_type==4){   //刷身份证
            this.show1 = true;
            this.swipe = ['1'];
          }else if(device.code.info.testing_type==6){   //刷身份证/医保卡/扫码（北京win）
            this.show1 = true;
            this.swipe = ['1','2','3'];
          }else if(device.code.info.testing_type==7){   //刷医保卡
            this.show1 = true;
            this.swipe = ['2'];
          }else if(device.code.info.testing_type==5){   //本地数据
            window.ipcRenderer.send("getFileInfo");
            window.ipcRenderer.on("setFileInfo", (e, data) => {
              if(data.code){
                  data.data = JSON.parse(data.data);
                  console.log(data.data);
                  let info = {
                    userName:data.data.name,
                    gender:data.data.sex,
                    birthday:data.data.birthday,
                    idCode:data.data.id_card,
                    height:data.data.height?data.data.height:'',
                    weight:data.data.weight?data.data.weight:'',
                    phone:data.data.phone?data.data.phone:'',
                    waistSize:data.data.waistSize?data.data.waistSize:'',
                    random:data.data.random
                  }
                  sessionStorage.setItem("info",JSON.stringify(info));
                  let equipment = JSON.parse(sessionStorage.getItem('equipment'));
                  _this.axiosTel({
                    data:{
                        company_id:equipment?equipment.sys_company_id:'',
                        phone:'',
                        name:data.data.name,
                        birthday:data.data.birthday
                    },
                    func:()=>{
                      //语音
                      audioPaly.play(welcome);
                      _this.$router.push({
                          name:'confirmAssess'
                      });
                    }
                  })
              }else{
                sessionStorage.removeItem('info');
                audioPaly.play(welcome);
                _this.$router.push({
                    name:'confirmAssess'
                });
              }
            });
          }else{
            _this.deviceFun((mac)=>{
              _this.axiosData({
                data:{mac:mac},
                _this:this,
                fun:()=>{
                    //语音
                    audioPaly.play(welcome);
                    _this.$router.push({
                        name:'confirmAssess'
                    });
                }
              });
            })
            
          }
        }
      },
      //网络异常时重新发送请求
      retryFun(){
        this.swipeKey++;
        this.deviceFun(this.axiosFun);
      },
      //退出登录
      noLoginFun(){
          this.changeFun({
              key:'history',
              value:false
          })
      },
      historyLoginFun(){
          if(sessionStorage.token){
            this.$router.push({
                name:'reportList'
            });
          }else{
            //登录
            this.changeFun({
                key:'history',
                value:true
            })
          }
      },
      showFun(){
        this.show = false;
      },
      ...mapMutations ("report", ["changeFun"]),
      ...mapMutations ("device", ["changeDFun"]),
      ...mapActions('device',['axiosData','identityData','axiosTel','userReviseData','codeData','swipeData']),
  }
}
</script>

<style lang="scss" scoped> 
    @import './device'; 
</style>